/* Карты — общее хранилище реквизитов команды, соседний раздел к паролям.
   Своего названия у карты нет, поэтому строка подписана последними четырьмя
   цифрами: по ним карту и узнают. */

import { List, ListItem } from "konsta/react";
import React from "react";
import { useNavigate } from "../lib/router.jsx";

import AddButton from "../components/AddButton.jsx";
import { Ion, IconTile } from "../components/icons.jsx";
import Screen from "../components/Screen.jsx";
import { SkelList } from "../components/skeleton.jsx";
import { Empty, ErrorState } from "../components/ui.jsx";
import { useFetch } from "../lib/store.jsx";
import { haptic } from "../lib/tg.js";

const TILE = "#a2845e";

const ITEM_COLORS = {
  primaryTextIos: "text-[color:var(--tg-text)]",
  secondaryTextIos: "text-[color:var(--tg-hint)]",
};

/** «•••• 1234» — номер целиком в списке не нужен */
export const cardLabel = (number) => {
  const digits = String(number || "").replace(/\D/g, "");
  return digits.length > 4 ? `•••• ${digits.slice(-4)}` : digits || "—";
};

export default function Cards() {
  const { data, loading, error, refetch } = useFetch("/cards");
  const navigate = useNavigate();
  const items = data || [];

  return (
    <Screen back title="Карты" bottomPad={110}>
      {loading ? <SkelList /> : null}
      {error ? <ErrorState text={error} onRetry={refetch} /> : null}

      {!loading && !error && !items.length ? <Empty text="Карт пока нет" icon={Ion.card} /> : null}

      {items.length ? (
        <List strong inset>
          {items.map((c) => (
            <ListItem
              key={c.id}
              link
              colors={ITEM_COLORS}
              media={<IconTile icon={Ion.cardSolid} bg={TILE} />}
              title={<span className="num">{cardLabel(c.number)}</span>}
              after={c.holder || c.year}
              onClick={() => { haptic.light(); navigate(`/edit/cards/${c.id}`); }}
            />
          ))}
        </List>
      ) : null}

      <AddButton onClick={() => { haptic.medium(); navigate("/edit/cards/new"); }} />
    </Screen>
  );
}
